import { Grid } from 'portal-commons';
import { FC } from 'react';

interface SectionContentProps {
  columns?: number;
}

const SectionContent: FC<SectionContentProps> = ({ columns = 4, children }) => (
  <Grid
    sx={{
      gridTemplateColumns: `repeat(${columns}, 1fr)`,
      rowGap: 'm',
      columnGap: 'l',
      width: '100%',
    }}
  >
    {children}
  </Grid>
);

export default SectionContent;
